import { useState, useEffect } from 'react'
import theme from '../theme'

export const useWidth = () => {
    const [width, setWidth] = useState(window.innerWidth)
    const bp = theme.breakpoints
    const sm = bp.values.sm // 600px
    const md = bp.values.md // 900px
    const lg = bp.values.lg // 1200px
    const xl = bp.values.xl // 1536px

    useEffect(() => {
        const handleResize = () => { setWidth(window.innerWidth) }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    if (width < sm) return 'xs'
    if (width >= sm && width < md) return 'sm'
    if (width >= md && width < lg) return 'md'
    if (width >= lg && width < xl) return 'lg'
    if (width >= xl) return 'xl'
}

export function screenWidth() {
    const width = window.innerWidth
    // const bp = theme.breakpoints

    /* const sm = bp.values.sm // 600px
    const md = bp.values.md // 900px
    const lg = bp.values.lg // 1200px
    const xl = bp.values.xl // 1536px */

    const sm = 600
    const md = 900
    const lg = 1200
    const xl = 1536

    if (width < sm) return 'xs'
    if (width >= sm && width < md) return 'sm'
    if (width >= md && width < lg) return 'md'
    if (width >= lg && width < xl) return 'lg'
    if (width >= xl) return 'xl'
}

export const useBreakpoint = () => {
    const width = useWidth()
    const [bp, setBp] = useState(null)

    useEffect(() => {
        if (width === 'xs' || width === 'sm') setBp('mobile')
        else if (width === 'md') setBp('tablet')
        else setBp('desktop')
    }, [width])

    return bp
}